import DVCore, { BaseAPI } from './core/DVCore';

const QrAPI = BaseAPI('/api/qr/');

QrAPI.myQR = (onSuccess, onFail, onError = null) => {
    return DVCore.get(QrAPI.baseURL + 'myQR', null, onSuccess, onFail, onError);
};

export default QrAPI;
